module.exports = __webpack_public_path__ + "static/media/IMG_8928.4c365bf9.JPG";